const moduleSel = (state: any): any => state.msrp;

export const showOnlyMsrpSel = (state: any) => moduleSel(state).showOnlyMSRP;
